import { render } from "./consumpsion_chart.vue?vue&type=template&id=223e1429"
import script from "./consumpsion_chart.vue?vue&type=script&lang=js"
export * from "./consumpsion_chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__